/**
 * @packageDocumentation
 * @module HackerAPI.Event.Update
 */
import { __extends } from "tslib";
import Base from "../../base/base";
import HackerAPIFetch from "../../hackerapi-fetch/hackerapi-fetch";
import { parseDate } from "../../utils/utils";
/**
 * A data container for an event update
 * @class
 * @extends { HackerAPI.Base }
 */
var Update = /** @class */ (function (_super) {
    __extends(Update, _super);
    /**
     * Creates a new Update object
     * @constructor
     * @param update
     */
    function Update(_a) {
        var _b = _a === void 0 ? {} : _a, id = _b.id, title = _b.title, description = _b.description, category = _b.category, links = _b.links, send_time = _b.send_time, sendTime = _b.sendTime, created_at = _b.created_at, createdAt = _b.createdAt, updated_at = _b.updated_at, updatedAt = _b.updatedAt;
        var _this = _super.call(this, {
            sendTime: Base.dateTimeHandler
        }) || this;
        /**
         * The ID for the update
         * @type { number }
         */
        _this.id = id;
        /**
         * The title of the update
         * @type { string }
         */
        _this.title = title;
        /**
         * The description of the update
         * @type { string }
         */
        _this.description = description;
        /**
         * The category of the update
         * @type { string }
         */
        _this.category = category;
        /**
         * Links related to the update
         * @type { string[] }
         */
        _this.links = links;
        /**
         * The time the update should be sent out at
         * @type { Date }
         */
        _this.sendTime = parseDate(send_time || sendTime);
        /**
         * When the update was created
         * @type { Date }
         */
        _this.createdAt = parseDate(created_at || createdAt);
        /**
         * When the update was last updated
         * @type { Date }
         */
        _this.updatedAt = parseDate(updated_at || updatedAt);
        return _this;
    }
    /**
     * Gets all the updates for an event
     * @param event - The event to get updates for
     * @param event.slug
     * @returns The list of updates for the event
     */
    Update.fetchAll = function (_a) {
        var slug = _a.slug;
        return HackerAPIFetch({
            path: "/v2/events/" + slug + "/updates",
            method: "GET"
        }).then(function (data) { return data.map(function (datum) { return new Update(datum); }); });
    };
    /**
     * Adds an update to hackerapi
     * @param event - The event to add an update for
     * @param event.slug
     * @param update - The update to push
     * @param token
     * @returns
     */
    Update.create = function (_a, update, token) {
        var slug = _a.slug;
        return HackerAPIFetch({
            path: "/v2/events/" + slug + "/updates",
            method: "POST",
            body: update.toHackerAPIFormat(),
            token: token
        }).then(function (data) { return new Update(data); });
    };
    /**
     * Deletes an update
     * @param event - The event the update is for
     * @param event.slug
     * @param update - The update to delete
     * @param update.id
     * @param token
     * @returns
     */
    Update.deleteUpdate = function (_a, _b, token) {
        var slug = _a.slug;
        var id = _b.id;
        return HackerAPIFetch({
            path: "/v2/events/" + slug + "/updates/" + id,
            method: "DELETE",
            token: token
        });
    };
    return Update;
}(Base));
export default Update;
//# sourceMappingURL=update.js.map